import { render } from "./leaderboard.vue?vue&type=template&id=315b4e4a&scoped=true"
import script from "./leaderboard.vue?vue&type=script&lang=js"
export * from "./leaderboard.vue?vue&type=script&lang=js"

import "./leaderboard.vue?vue&type=style&index=0&id=315b4e4a&lang=scss&scoped=true"
import "./leaderboard.vue?vue&type=style&index=1&id=315b4e4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315b4e4a"]])

export default __exports__